import { Component, ComponentFactoryResolver, ComponentRef, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {CadastroDetailsComponent} from '../../../views/cadastro/cadastros/cadastro/cadastro-details/cadastro-details.component';

@Component({
    selector: 'app-modal-wrapper',
    templateUrl: './modal-wrapper.component.html',
})
export class ModalWrapperComponent implements OnInit {

    @ViewChild('container', { read: ViewContainerRef, static: true }) container: ViewContainerRef;
    @Input() componentName: string;

    private componentRef: ComponentRef<{}>;
    private componentsMapping = {
        cadastroDetailsComponent: CadastroDetailsComponent,

    };

    constructor(private componentFactoryResolver: ComponentFactoryResolver) {
    }

    ngOnInit(): void {
        const component = this.componentsMapping[this.componentName];

        const factory = this.componentFactoryResolver.resolveComponentFactory(component);
        this.componentRef = this.container.createComponent(factory);

    }
}